import { render, staticRenderFns } from "./wthdrawWarning.vue?vue&type=template&id=6a8e2084&scoped=true"
import script from "./wthdrawWarning.vue?vue&type=script&lang=js"
export * from "./wthdrawWarning.vue?vue&type=script&lang=js"
import style0 from "./wthdrawWarning.vue?vue&type=style&index=0&id=6a8e2084&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a8e2084",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/xrUxRsdL/1/acquirer/pingpong-acquirer-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6a8e2084')) {
      api.createRecord('6a8e2084', component.options)
    } else {
      api.reload('6a8e2084', component.options)
    }
    module.hot.accept("./wthdrawWarning.vue?vue&type=template&id=6a8e2084&scoped=true", function () {
      api.rerender('6a8e2084', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/WthdrawOperationManual/wthdrawWarning.vue"
export default component.exports